// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--3Pyz6","layoutHomepage":"Layout-module--layoutHomepage--1Q7e6"};